import { render, staticRenderFns } from "./NetGsmExtensions.vue?vue&type=template&id=06db0793&scoped=true"
import script from "./NetGsmExtensions.vue?vue&type=script&lang=js"
export * from "./NetGsmExtensions.vue?vue&type=script&lang=js"
import style0 from "./NetGsmExtensions.vue?vue&type=style&index=0&id=06db0793&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db0793",
  null
  
)

export default component.exports